<template>
	<SimpleModalComponent
		heading="Add asset"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<div class="form__set">
				<label
					for="new_tag"
					class="form__label"
				>
					Title
				</label>
				<input
					id="title"
					:value="title"
					class="form__input form__input--stretch"
					type="text"
					name="title"
					placeholder=""
					:disabled="loading"
					@input="validateTitleInput"
				>
			</div>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				:disabled="loading"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				:class="{ 'button--loading' : loading }"
				:disabled="loading"
				@click="createNewAsset"
			>
				Add
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, defineProps, defineEmits } from 'vue';
import { useDataStore } from '../../stores/data';

const props = defineProps( {
	project: {
		required: true,
		type: Object
	},
	mediaTypeId: {
		required: true,
		type: Number
	},
} );

const emit = defineEmits( ['asset-added', 'close-modal'] );

const { createAsset } = useDataStore();

const loading = ref( false );
const title = ref( '' );
const error_message = ref( null );

const validateTitleInput = e => { // eslint-disable-line snakecasejs/snakecasejs
	const prev_value = title.value;
	title.value = null;

	const regex = /^[a-zA-Z0-9\ \-]*$/;
	const input = e.target.value;

	if ( regex.test( input ) ) {
		title.value = input;
	} else {
		title.value = prev_value;
	}
};

const createNewAsset = async() => { // eslint-disable-line snakecasejs/snakecasejs
	error_message.value = null;
	loading.value = true;

	if ( !title.value ) {
		error_message.value = 'Please enter a title';
		loading.value = false;
		return;
	}

	try {
		const new_asset = await createAsset( {
			project: props.project,
			asset_title: title.value,
			media_type_id: props.mediaTypeId
		} );

		if ( new_asset ) {
			emit( 'asset-added', {
				new_asset,
				media_type_id: props.mediaTypeId
			} );
		}

		loading.value = false;
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};
</script>